import { useEffect, useState } from "react";
import "@/App.css";
import "@/styles/pillauncoche.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CookieBanner from "@/components/CookieBanner";

import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Pilla3 from "@/pages/Pilla3";
import Compra from "@/pages/Compra";
import Faqs from "@/pages/Faqs";
import Noticias from "@/pages/Noticias";
import Checkout from "@/pages/Checkout";
import ReservaExito from "@/pages/ReservaExito";
import VerificacionCompleta from "@/pages/VerificacionCompleta";
import Admin from "@/pages/Admin";
import MiPerfil from "@/pages/MiPerfil";
import Cookies from "@/pages/Cookies";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";
import MaintenancePage from "@/pages/MaintenancePage";

import { ConfigProvider, useConfig } from "@/context/ConfigContext";
import { AuthProvider } from "@/context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.baseURL = BACKEND_URL;

// Attach customer session token automatically to outgoing requests
axios.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("pc_user");
    if (raw) {
      const u = JSON.parse(raw);
      if (u?.token) {
        config.headers = config.headers || {};
        config.headers["x-user-token"] = u.token;
      }
    }
  } catch (err) { /* ignore */ }
  return config;
});
function AppRoutes() {
  const { maintenance_mode } = useConfig();
  const isAdminRoute = window.location.pathname.startsWith("/admin");

  if (maintenance_mode && !isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/vehiculos" element={<Vehicles />} />
      <Route path="/vehiculo/:id" element={<VehicleDetail />} />
      <Route path="/pilla3" element={<Pilla3 />} />
      <Route path="/compra" element={<Compra />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/noticias" element={<Noticias />} />
      <Route path="/reservas" element={<Vehicles />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/reserva/exito" element={<ReservaExito />} />
      <Route path="/checkout/verificado" element={<VerificacionCompleta />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/mi-perfil" element={<MiPerfil />} />
      <Route path="/legal/cookies" element={<Cookies />} />
      <Route path="/legal/privacidad" element={<Privacidad />} />
      <Route path="/legal/terminos" element={<Terminos />} />
    </Routes>
  );
}
function App() {
  return (
    <div className="App pillauncoche-root">
      <ConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <Navbar />
            <main className="min-h-screen bg-white">
              <AppRoutes />
            </main>
            <Footer />
            <WhatsAppFloat />
            <CookieBanner />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
